module.exports = __webpack_public_path__ + "static/media/intro.40d07516.mp3";